export class FileHelpers {
  public static downloadConfig(config: string): void {
    const universalBOM = '\uFEFF';
    const a = window.document.createElement('a');
    a.setAttribute(
      'href',
      'data:application/json; charset=utf-8,' +
        encodeURIComponent(universalBOM + config)
    );
    a.setAttribute('download', 'config.json');
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
  }

  public static async save(config: string): Promise<void> {
    try {
      // @ts-ignore
      const fileHandle = await window.showSaveFilePicker({
        startIn: 'downloads',
        suggestedName: 'config.json',
        types: [
          {
            description: 'Config file',
            accept: {
              'application/json': ['.json'],
            },
          },
        ],
      });

      const writable = await fileHandle.createWritable();
      await writable.write(config);
      await writable.close();
    } catch (error) {
      console.warn(error);
    }
  }

  public static async saveAs(blob: Blob, fileNameWithExtension: string) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const url = reader.result as string;
      FileHelpers.download(url, fileNameWithExtension);
    };
    reader.readAsDataURL(blob);
  }

  public static download(url: string, fileNameWithExtension: string) {
    fetch(url, { mode: 'no-cors' })
      .then((transfer) => transfer.blob())
      .then((bytes) => {
        let elm = document.createElement('a'); // CREATE A LINK ELEMENT IN DOM
        elm.href = URL.createObjectURL(bytes); // SET LINK ELEMENTS CONTENTS
        elm.setAttribute('download', fileNameWithExtension); // SET ELEMENT CREATED 'ATTRIBUTE' TO DOWNLOAD, FILENAME PARAM AUTOMATICALLY
        elm.click();
      })
      .catch((error) => console.error(error));
  }
}
